document.addEventListener('DOMContentLoaded', () => {
  //select_boxes (insert)
  function select_boxes(el) {
    for (let i = 0; i < el.length; i++) {
      if(el[i].classList.contains('_category')){
        select_box_category(el[i]);
      }else{
        select_box(el[i]);
      }
    }
  }
  //select_box (insert)
  function select_box(el) {
    let s_b = $s(el, '.select');
    let s_b_o = $$s(el, '.option');
    let i_v = s_b.dataset.placeholder;
    let sel ="";
    let new_s_b = `<input class="input select-box-input" placeholder="${i_v}"></div>
    <ul class="select-box-parent">`;
    for (let j = 0; j < s_b_o.length; j++) {

      if (s_b_o[j].selected === 'selected') {
        sel = s_b_o[j].text;
        new_s_b += `<li class="select-box-item is-active">${s_b_o[j].text}</li>`;
      } else {
        new_s_b += `<li class="select-box-item">${s_b_o[j].text}</li>`;
      }
    }
    new_s_b += `</ul>`;
    s_b.insertAdjacentHTML("afterend", new_s_b);
    let s_b_i = $s(el, '.select-box-input');
    s_b_i.value = sel;
  }
  //END select_box (insert)
  //select_box_category (insert)
  function select_box_category(el) {
    let cat_array = [];
    let obj = {};
    let s_b = $s(el, '.select');
    let s_b_o = $$s(el, '.option');
    let selected = false;
    for (let i = 0; i < s_b_o.length; i++) {
      s_b_o[i].selected ? selected = true : selected= false;
      obj = {
        id: s_b_o[i].value,
        old_index: i,
        parent: s_b_o[i].dataset.parent,
        name:`${s_b_o[i].text}`,
        selected: selected,
        space: 0,
        child: false
      };
      if(s_b_o[i].dataset.parent === ""){
        cat_array.unshift(obj);
      }else{
        cat_array.push(obj); 
      }
    }
    function array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
          var k = new_index - arr.length + 1;
          while (k--) {
              arr.push(undefined);
          }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr; 
    };
    function category_sort(arr){
      for (let i = 0; i < arr.length; i++) {
        if(arr[i].parent !== ""){
          for (let j = 0; j < arr.length; j++) {
            if(arr[j].id === arr[i].parent){
              arr[i].space += 1;
              arr[i].space += arr[j].space;
              arr[j].child = true;
              array_move(arr, i, j);
            }
          }
        }
      }
    }
    category_sort(cat_array);
    cat_array.reverse();

    let i_v = s_b.dataset.placeholder;
    let sel = "";
    let active = "";
    let style = "";
    let style1 = "";
    let style2 = "";
    let bold_name = "";
    let new_s_b = `<input class="input select-box-input" placeholder="${i_v}">
    <ul class="select-box-parent">`;
    for (let i = 0; i < cat_array.length; i++) {
      if(cat_array[i].selected){
        sel = cat_array[i].name;
        active = "is-active";
      }else{
        active = "";
      }
      if(cat_array[i].parent === ""){
        style = `padding-right:25px;`
        style1 = ``;
        style2 = "";
      }else{
        style = `padding-right:${cat_array[i].space + 25}px;`
        style1 = `margin-right:${cat_array[i].space * 29}px;`;
        style2 = "border-right: 1px dashed #f7b2aa;"
      }
      cat_array[i].child ? bold_name=`<b>+ ${cat_array[i].name}</b>` : bold_name=`${cat_array[i].name}`;
      new_s_b += `<li class="select-box-item ${active}"
                    style="${style} ${style1} ${style2}" data-index="${cat_array[i].old_index}">
                    ${bold_name}
                  </li>`;
    }
    new_s_b += `</ul>`;
    s_b.insertAdjacentHTML("afterend", new_s_b);
    let s_b_i = $s(el, '.select-box-input');
    s_b_i.value = sel;

    function category_list(cat_array) {
      let new_s_b = `<ul class="category-box-parent">`;
      for (let i = 1; i < cat_array.length; i++) {
        if(cat_array[i].parent === ""){
          style = `padding-right:22px;`
          style1 = ``;
          style2 = "";
        }else{
          style = `padding-right:${cat_array[i].space + 22}px;`
          style1 = `margin-right:${cat_array[i].space * 29}px;`;
          style2 = "border-right: 1px dashed #f7b2aa;"
        }
        cat_array[i].child ? bold_name=`<b><svg style="width:18px;height:18px" viewBox="0 0 24 24">
                                            <path fill="gray" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z">
                                            </path>
                                        </svg> ${cat_array[i].name}</b>` : bold_name=`${cat_array[i].name}`;
        new_s_b += `<li style="${style} ${style1} ${style2}" data-index="${cat_array[i].old_index}">
                      ${bold_name}   &nbsp&nbsp&nbsp  
                      <small><a href="" class="">(حذف)</a></small>&nbsp 
                      <small><a href="">(ویرایش)</a></small>
                    </li>`;
      }
      new_s_b += `</ul>`;
      if($('.product-categories')){ 
        let p_c = $('.product-categories');
        p_c = $s(p_c, '.box_');
        p_c.insertAdjacentHTML("afterend", new_s_b);
      }
    }
    category_list(cat_array);
  }
  //END select_box_category (insert)
  is('.select-box', select_boxes($$('.select-box')));
  //END select_boxes (insert)
  //select_box_item
  function select_box_item() {
    let cls = ['is-active'];
    let s_b = this.closest('.select-box');
    let i_v = ($s(s_b, '.select')).dataset.placeholder;
    let sel = "";
    let s_b_i = $s(s_b, '.select-box-input');
    let s_b_o = $$s(s_b, '.option');
    let s_b_p = this.parentElement;
    let s_b_items = $$s(s_b_p, '.select-box-item');
    let old_index = "";
    const index = Array.from(s_b_items).indexOf(this);
    if (s_b.classList.contains('multiple')) {
      if (s_b_o[index].selected) {
        this.classList.remove(...cls);
        s_b_o[index].selected = false;
      } else {
        this.classList.add(...cls);
        s_b_o[index].selected = true;
        s_b_i.value = s_b_o[index].text;
        var i_status = 1;
      }
      let count = 0;
      for (let i = 0; i < s_b_o.length; i++) {
        s_b_items[i].style.display = "";
        if (s_b_o[i].selected) {
          count += 1;
          if (!i_status) s_b_i.value = s_b_o[i].text;

        }
      }
      i_status = 0;
      if (count > 1) { s_b_i.value += ` و ${--count} مورد دیگر ` }
      else if (count == 0) { s_b_i.value = "${i_v" };
    } 
    else {
      for (let i = 0; i < s_b_items.length; i++) {
        s_b_items[i].classList.remove(...cls);
        s_b_items[i].style.display = "";
      }
      this.classList.add(...cls);
      if(s_b.classList.contains('_category')){
        old_index = this.dataset.index;
        s_b_o[old_index].selected = true;
        s_b_i.value = s_b_o[old_index].text;
      }else{
        s_b_o[index].selected = true;
        s_b_i.value = s_b_o[index].text;
      }
      s_b_p.classList.remove(...cls);
    }
  }

  //END select_box_item
  //select_box_input
  function select_box_input() {
    let cls = ['is-active'];
    let s_b_p = this.nextElementSibling;
    s_b_p.classList.add(...cls);
    let s_b_i = $$s(s_b_p, '.select-box-item');
    for(let el of s_b_i) {
    	el.style.display = "";
    }
  }
  
  //END select_box_input
  //select_box show hide
  function select_box_show() {
    let cls = ['is-active'];
    let s_b_p = $s(this, '.select-box-parent');
    s_b_p.classList.add(...cls);
  }
  function select_box_hide() {
    let cls = ['is-active'];
    let s_b_p = $s(this, '.select-box-parent');
    let i_b = $s(this,'.select-box-input');
    i_b.blur();
    s_b_p.classList.remove(...cls);
  }
  
  
  //END select_box show hide
  //select_box_input
  function select_box_input_filter() {
    let cls = ['is-active'];
    let s_b_p = this.nextElementSibling;
    if (!s_b_p.classList.contains('is-active')) { s_b_p.classList.add(...cls); }
    let filter = this.value;
    let s_box = this.parentElement;
    let s_b_items = $$s(s_box, '.select-box-item');
    for (let i = 0; i < s_b_items.length; i++) {
      let txt_value = s_b_items[i].innerText;
      if (txt_value.indexOf(filter) > -1) {
        s_b_items[i].style.display = "";
      } else {
        s_b_items[i].style.display = "none";
      }

    }

  }
$e('.select-box-item', select_box_item,['click']);
$e('.select-box-input', select_box_input,['focus']);
// $e('.select-box', select_box_show,['mouseenter']);
$e('.select-box', select_box_hide,['mouseleave','blur']);
// $e('.select-box', select_box_show,['focus']);
$e('.select-box-input', select_box_input_filter,['keyup']);
  //END select_box_input
});
